import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { RootState } from '../reducers';
import { fethcDataAssistants } from '../reduxactions/suprivisoractions/SupAssistantDetActions';
import useEffectOnce from '../hooks/useEffectOnce';
import { InputText } from 'primereact/inputtext';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { StepperPanel } from 'primereact/stepperpanel';
import { Button } from 'primereact/button';
import { Stepper } from 'primereact/stepper';
export const SupAssistantDetails = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);
    const stepperRef = useRef(null);

    const location = useLocation();
    const dispatch = useDispatch();

    const [queryParams, setQueryParams] = useState(null);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("id") as any);
    }, [location]);
    const { id } = useParams();
    const assistantdata = useSelector((state: RootState) => state.sassistantdetails.data);

    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fethcDataAssistants(id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffectOnce(() => {
        fetchDataAsync();
    }, [dispatch]);
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/viewsup-assistent.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="content-header">
                            <div className="container-fluid">
                                <div className="grid mb-2">

                                    <div className="col-9">
                                        <h1>Profile</h1>
                                    </div>
                                    <div className="col-3">
                                        <a
                                            title="help"
                                            onClick={(e) => openWindow(e, IUrl)}
                                            style={{

                                                color: "blue",
                                                fontSize: 15, cursor: "pointer"
                                            }}
                                        >Help for this Page &nbsp;
                                            <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section >
                        <section className="content">



                            {assistantdata.map((response: any) =>
                                <>

                                    <div>
                                        <Stepper ref={stepperRef}>


                                            {/* <TabMenu> */}

                                            <StepperPanel header="Personal Info">
                                                <div className="grid">

                                                    <div className="col-3">
                                                        <div className="flex flex-column align-items-center font-bold m-2 border-round border-1 border-blue-500 bg-white" style={{ width: "100%", padding: "20px" }}>
                                                            <a key={response.id}>
                                                                <img src={response.photo} style={{ width: '150px', height: '150px', borderRadius: '50%' }} className="profile-user-img img-responsive img-circle" />
                                                            </a>
                                                            <h3 className="profile-username text-center mt-3">{response.firstName}</h3>
                                                            <br></br>
                                                            <h3>Assistant</h3>


                                                        </div>
                                                    </div>



                                                    <div className="col-9">
                                                        <Card className='border-blue-300 surface-overlay border-3 border-round '>

                                                            <Panel header="Personal Details" toggleable  >
                                                                <div className='grid'>
                                                                    <div className="col-6">


                                                                        <div className="col-3">
                                                                            <label htmlFor="fname" className="block text-900 font-medium ">First Name</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="fname" type="text" disabled className="w-full mb-3" value={response.firstName} />
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="lname" className="block text-900 font-medium">Last Name</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="lname" type="text" disabled className="w-full mb-3" value={response.lastName} />
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="email" className="block text-900 font-medium ">E-mail</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="email" type="text" className="w-full mb-3" disabled value={response.email} />
                                                                        </div>
                                                                        <div className="col-5">
                                                                            <label htmlFor="email" className="block text-900 font-medium ">Phone Number</label>

                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="email" type="text" disabled className="w-full mb-3" value={response.phone} />

                                                                        </div>


                                                                        <div className="col-3">
                                                                            <label htmlFor="phone" className="block text-900 font-medium ">Address</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText
                                                                                type="tel"
                                                                                value={response.address}
                                                                                disabled
                                                                                placeholder="Enter Address "
                                                                                className="w-full mb-3"
                                                                            />
                                                                        </div>

                                                                        <div className="col-3">
                                                                            <label htmlFor="cardno" className="block text-900 font-medium ">City</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.city} />
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="cardno" className="block text-900 font-medium ">State </label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.state} />
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="cardno" className="block text-900 font-medium ">Country </label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.country} />
                                                                        </div>


                                                                    </div>

                                                                </div>
                                                            </Panel>
                                                            <br></br>

                                                        </Card>

                                                    </div>
                                                </div>
                                            </StepperPanel>

                                            <StepperPanel header="Hospital Info">
                                                <div className="grid">

                                                    <div className="col-3">
                                                        <div className="flex flex-column align-items-center font-bold m-2 border-round border-1 border-blue-500 bg-white" style={{ width: "100%", padding: "20px" }}>
                                                            <a key={response.id}>
                                                                <img src={response.photo} style={{ width: '150px', height: '150px', borderRadius: '50%' }} className="profile-user-img img-responsive img-circle" />
                                                            </a>
                                                            <h3 className="profile-username text-center mt-3">{response.firstName}</h3>
                                                            <br></br>
                                                            <h3>Assistant</h3>
                                                        </div>
                                                    </div>




                                                    <div className="col-9">
                                                        <Card className='border-blue-300 surface-overlay border-3 border-round '>

                                                            <Panel header="Hospital Details" toggleable  >
                                                                <div className='grid'>
                                                                    <div className="col-6">


                                                                        <div className="col-3">
                                                                            <label htmlFor="fname" className="block text-900 font-medium ">Hospital Name</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="fname" type="text" disabled className="w-full mb-3" value={response.hospitalname} />
                                                                        </div>
                                                                        <div className="col-3">
                                                                            <label htmlFor="lname" className="block text-900 font-medium">Hospital Prefix</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="lname" type="text" disabled className="w-full mb-3" value={response.hospitalprefix} />
                                                                        </div>
                                                                        <div className="col-2">
                                                                            <label htmlFor="email" className="block text-900 font-medium ">E-mail</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="email" type="text" className="w-full mb-3" disabled value={response.hemail} />
                                                                        </div>
                                                                        <div className="col-2">
                                                                            <label htmlFor="email" className="block text-900 font-medium ">Phone</label>

                                                                        </div>
                                                                        <div className="col-12">
                                                                            {/* <Dropdown value={.gender}  options={genderoptions} optionLabel="label" optionValue='value' placeholder="Select Gender" className="w-full mb-3" /> */}
                                                                            <InputText id="email" type="text" disabled className="w-full mb-3" value={response.hphone} />

                                                                        </div>


                                                                        <div className="col-2">
                                                                            <label htmlFor="phone" className="block text-900 font-medium ">Address</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText
                                                                                type="tel"
                                                                                value={response.address}
                                                                                disabled
                                                                                placeholder="Enter Phone Number"
                                                                                className="w-full mb-3"
                                                                            />
                                                                        </div>

                                                                        <div className="col-1">
                                                                            <label htmlFor="cardno" className="block text-900 font-medium ">City</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.hcity} />
                                                                        </div>
                                                                        <div className="col-2">
                                                                            <label htmlFor="cardno" className="block text-900 font-medium ">State </label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.hstate} />
                                                                        </div>
                                                                        <div className="col-2">
                                                                            <label htmlFor="cardno" className="block text-900 font-medium ">Country </label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.hcountry} />
                                                                        </div>
                                                                        <div className="col-2">
                                                                            <label htmlFor="cardno" className="block text-900 font-medium ">Pincode</label>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.pin} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Panel>
                                                            <br></br>

                                                        </Card>

                                                    </div>
                                                </div>

                                            </StepperPanel>


                                        </Stepper>


                                    </div>


                                </>
                            )}

                        </section>

                    </div>
                </div>
            </div>






        </div>
    )
}
